<template>
    <div class="page-section">
        <header>
            <div class="header row">
                <div class="col s12 colfix">
                     <span class="close"
                           v-on:click="$emit('closePage')"
                     ></span>
                    <span class="logo">
                        <img :src="pageData.logo"/>
                    </span>

                </div>
            </div>
        </header>
        <section class="content">
            <div class="container page">
                <div class="hero">
                    <div class="row">
                        <div class="img-wrap col s12 m12 l6">
                            <div class="image"
                            >
                                <!--v-bind:style="{ backgroundImage: 'url(' + curentEnvironment.image + ')' }"-->
                                <img :src="curentEnvironment.image"/>
                            </div>

                        </div>
                        <div class="text-wrap col s12  m12 l6">
                            <h3 class="title">{{pageData.title}}</h3>

                            <div class="description"
                                 v-html="pageData.description"
                            >

                            </div>
                        </div>
                    </div>
                </div>

                <div class="technologies"
                     v-bind:class="[showPage]"
                >
                    <div class="row">
                        <div class="col s12">
                            <h3
                            v-html="pageData.techno_title"
                            ></h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12 m6 l4 xl3"
                             v-for="technology in pageData.technologies"
                        >
                            <div class="itemtech"
                            >
                                <!--v-bind:style="{ 'min-height': itemtechMinHeight + 'px' }"-->
                                <div class="image-block">
                                    <img :src="technology.image"/>
                                </div>
                                <div class="content-block">
                                    <h4 class="title"
                                    v-html="technology.title"
                                    >
                                    </h4>
                                    <div class="description"
                                         v-html="technology.description"
                                    >
                                    </div>

                                </div>
                                <div class="disclaimer"
                                     v-if="technology.disclaimer"
                                >
                                    Read disclaimers
                                    <div class="disclaimer-text"
                                    v-html="technology.disclaimer"
                                    >
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>


            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "pageIntel",
        props: ['showPage', 'curentEnvironment'],
        data() {
            return {
                itemtechMinHeight: 1,
            }
        },
        computed: {
            pageData: function () {
                return this.globalData[this.showPage];
            }
        },
        watch: {},
        updated() {
            // this.setMinHeight();
        },
        mounted() {

            window.addEventListener('load', () => {
                this.setMinHeight();
            })
            this.setMinHeight();
            // setTimeout(this.setMinHeight(),1000)
        },
        created() {
            window.addEventListener("resize", this.setMinHeight);
        },
        destroyed() {
            window.removeEventListener("resize", this.setMinHeight);
        },
        methods: {
            setMinHeight() {
                //itemtech

                let iHs = [];
                var items = document.getElementsByClassName("itemtech");

                this.itemtechMinHeight = 0
                items.forEach((item, i) => {
                    let id = item.offsetTop;
                    if (!iHs.hasOwnProperty(id)) {
                        iHs[id] = {
                            el: []
                        };
                        this.itemtechMinHeight = 0;
                    }
                    if (this.itemtechMinHeight < (item.offsetHeight + 37)) {
                        this.itemtechMinHeight = (item.offsetHeight + 37);
                    }
                    iHs[id].el.push(item)
                    iHs[id].el.forEach((el, i) => {
                        el.style.minHeight = this.itemtechMinHeight + 'px';
                    })


                });
                // items.forEach((item, i) => {
                //     let id = item.offsetTop;
                //     console.log(id);
                //     if (iHs.hasOwnProperty(id)){
                //         // this.itemtechMinHeight = iHs[id]; //= item.offsetHeight
                //         item.style.minHeight = iHs[id]+'px';
                //
                //     }
                //     // if(this.itemtechMinHeight< item.offsetHeight){
                //     //     this.itemtechMinHeight= item.offsetHeight
                //     // }
                //
                // });


                // this.animateStart = true;
                // let iHs=[];
                // let items = document.getElementsByClassName("table-item");
                // items.forEach((item, i) => {
                //     let id = item.offsetTop
                //     if (!iHs.hasOwnProperty(id)){
                //         iHs[id]={
                //             imgH:0,
                //             imgT:0,
                //         };
                //     }
                //     if (iHs[id].imgH < item.querySelector('.env-img').offsetHeight) {
                //         iHs[id].imgH = item.querySelector('.env-img').offsetHeight
                //     }
                //     if (iHs[id].imgT < item.querySelector('.description').offsetHeight) {
                //         iHs[id].imgT = item.querySelector('.description').offsetHeight
                //     }
                // });
                // items.forEach((item, i) => {
                //     let id = item.offsetTop
                //     if (iHs.hasOwnProperty(id)){
                //         item.querySelector('.img-wrap').style.minHeight = iHs[id].imgH+'px';
                //         item.querySelector('.text-wrap').style.minHeight = iHs[id].imgT+'px';
                //     }
                // });


            }
        }
    }
</script>

<style lang="scss" scoped>

</style>